import { render, staticRenderFns } from "./Portfolio_preferences.vue?vue&type=template&id=5ce034e3&scoped=true&"
import script from "./Portfolio_preferences.vue?vue&type=script&lang=js&"
export * from "./Portfolio_preferences.vue?vue&type=script&lang=js&"
import style0 from "./Portfolio_preferences.vue?vue&type=style&index=0&id=5ce034e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce034e3",
  null
  
)

export default component.exports